module.exports = __webpack_public_path__ + "static/img/s-mi-3.a0d8c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-mi-3.png
// module id = rWUx
// module chunks = 1